export default __webpack_public_path__ + "static/media/Miscellaneous02.c9982f29.jpg";